// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"4bd42dde","970":"d5bb65a9","977":"240addac"}[chunkId] + ".chunk.js";
};